import {flow, get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {
  METRIC_ATTR_IS_LOADING,
  METRIC_ATTR_LAST_REFRESHED,
} from '/enum/metric.enum';
import {fromProps} from '/util/selector.util';

import {metric as metricState} from './root.selector';

export const metricMeta = createSelector(metricState, get('metricMeta'));

export const metricMetaByKey = createSelector(
  fromProps(get('metaKey')),
  metricMeta,
  (metaKey, meta) => {
    return get(metaKey)(meta);
  },
);

export const metricIsLoadingByKey = createSelector(
  metricMetaByKey,
  flow(get(METRIC_ATTR_IS_LOADING), Boolean),
);

export const metricLastRefreshedByKey = createSelector(
  metricMetaByKey,
  get(METRIC_ATTR_LAST_REFRESHED),
);
